import React from "react";
import { FaPhone } from "react-icons/fa";
import "../Location/Location.css";

const Location = () => {
  return (
    <div className="location">
      {/* Left Location Section */}
      <div className="left-loc">
        <h1>Our Location</h1>
        <h5>
          Plot No. C2, Sector - ECOTECH - XII, Greater Noida W Rd, Surajpur,
          Greater Noida, Uttar Pradesh 201310
        </h5>
        <button className="call-button">
          <FaPhone className="phone-icon" /> Call Us
        </button>
      </div>

      {/* Right Location Section */}
      <div className="right-loc">
        <h2>Landmark Attractions</h2>
        <img
          src="location.webp"
          alt="Associated Partners"
          className="partner-image"
        />
      </div>
    </div>
  );
};

export default Location;
